import React from 'react'
import {Container} from '@bootstrap-styled/v4'
import {StaticQuery, graphql} from 'gatsby'
import WOW from 'react-wow';

import * as S from './styled'

const PageHeader = ({title, category, subTitle, size, customBg}) => {
    return (
        <StaticQuery
            query={graphql `query { headerBg: file(relativePath: { eq: "backgrounds/bg-header-2.png"}){ childImageSharp { fluid(maxWidth: 1400){ ...GatsbyImageSharpFluid } } }, botBg: file(relativePath: { eq: "backgrounds/fluid-bot-5.png"}){ childImageSharp { fluid(maxWidth: 1400){ ...GatsbyImageSharpFluid } } } } `}
            render={data => (
            <S.PageHeaderWrapper
                size={size}
                customBg={customBg}
                fluid={data.headerBg.childImageSharp.fluid}
                Tag="header">
                <div className="custom-bg-overlay"></div>
                <Container style={{
                    height: '100%'
                }}>
                    <WOW animation="fadeInUp">
                        <S.PageHeaderContent>
                            {category && <S.PageHeaderTag>
                                {category}
                            </S.PageHeaderTag>}
                            <S.PageHeaderTitle size={size}>
                                {title}
                            </S.PageHeaderTitle>
                            <S.PageHeaderSubTitle>
                                {subTitle}
                            </S.PageHeaderSubTitle>
                        </S.PageHeaderContent>
                    </WOW>
                </Container>
                <S.PageHeaderCurveBottom fluid={data.botBg.childImageSharp.fluid}/>
            </S.PageHeaderWrapper>
        )}/>
    )
}

export default PageHeader;